<div class="row">
  <div class="col-md-12">

    <nb-card>
      <nb-card-header>{{ 'tytul.moje-konto' | translate }}</nb-card-header>
      <nb-card-body>
        <form *ngIf="(konto$ | async) as konto">
          <div class="form-group">
            <label for="nazwisko" class="label">E-mail</label>
            <input type="email" nbInput fullWidth id="email" placeholder="E-mail" value="{{konto.email}}">
          </div>
          <div class="form-group">
            <label for="imie" class="label">{{ 'etykieta.imie' | translate }}</label>
            <input type="text" nbInput fullWidth id="imie" placeholder="{{ 'etykieta.imie' | translate }}" value="{{konto.imie}}">
          </div>
          <div class="form-group">
            <label for="nazwisko" class="label">{{ 'etykieta.nazwisko' | translate }}</label>
            <input type="text" nbInput fullWidth id="nazwisko" placeholder="{{ 'etykieta.nazwisko' | translate }}" value="{{konto.nazwisko}}">
          </div>
          <div class="form-group">
            <nb-checkbox>{{ 'akcja.potwierdzam' | translate }}</nb-checkbox>
          </div>
          <button type="submit" nbButton status="danger">{{ 'akcja.zapisz' | translate }}</button>
        </form>
      </nb-card-body>
    </nb-card>

  </div>
</div>